var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShowerRain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9478 17.9425C21.7993 17.9425 23.2982 16.4437 23.2982 14.5922C23.2982 12.7407 21.7993 11.2418 19.9478 11.2418C19.9363 11.2418 19.9248 11.2418 19.9133 11.2418C19.6182 8.57767 17.3527 6.5 14.6003 6.5C12.4268 6.5 10.56 7.79567 9.72433 9.65483C9.6975 9.65483 9.67067 9.651 9.64383 9.651C7.35533 9.651 5.5 11.5063 5.5 13.7948C5.5 16.0833 7.35533 17.9387 9.64383 17.9387",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0803 17.9397C21.8702 17.8702 23.298 16.3991 23.298 14.592C23.298 12.7405 21.7992 11.2416 19.9477 11.2416H19.9132C19.9028 11.1484 19.8901 11.0559 19.875 10.9641C20.2421 10.8263 20.6399 10.751 21.0554 10.751C22.7804 10.751 24.2026 12.0543 24.3904 13.7333H24.4134C25.5749 13.7333 26.5179 14.6763 26.5179 15.8378C26.5179 16.9993 25.5749 17.9423 24.4134 17.9423L20.0803 17.9397Z",
    fill: "#CAD1E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06742 23.4853C8.97089 23.4853 8.87436 23.4598 8.7835 23.4087C8.51094 23.2525 8.42009 22.9033 8.57624 22.6336L9.39677 21.214C9.55293 20.9414 9.89932 20.8477 10.1719 21.0067C10.4444 21.1629 10.5353 21.5121 10.3791 21.7818L9.55861 23.2014C9.45356 23.3831 9.26333 23.4853 9.06742 23.4853Z",
    fill: "url(#paint0_linear_4805_26880)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6416 23.4853C13.5451 23.4853 13.4486 23.4598 13.3577 23.4087C13.0852 23.2525 12.9943 22.9033 13.1505 22.6336L13.971 21.214C14.1272 20.9414 14.4735 20.8477 14.7461 21.0067C15.0187 21.1629 15.1095 21.5121 14.9534 21.7818L14.1328 23.2014C14.0278 23.3831 13.8376 23.4853 13.6416 23.4853Z",
    fill: "url(#paint1_linear_4805_26880)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2159 23.4853C18.1193 23.4853 18.0228 23.4598 17.9319 23.4087C17.6594 23.2525 17.5685 22.9033 17.7247 22.6336L18.5452 21.214C18.7014 20.9414 19.0478 20.8477 19.3203 21.0067C19.5929 21.1629 19.6837 21.5121 19.5276 21.7818L18.707 23.2014C18.602 23.3831 18.4118 23.4853 18.2159 23.4853Z",
    fill: "url(#paint2_linear_4805_26880)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4873 25.5239C10.3908 25.5239 10.2943 25.4984 10.2034 25.4472C9.93086 25.2911 9.84001 24.9419 9.99617 24.6721L10.8167 23.2525C10.9729 22.98 11.3192 22.8863 11.5918 23.0453C11.8644 23.2014 11.9552 23.5507 11.7991 23.8204L10.9785 25.24C10.8735 25.4217 10.6833 25.5239 10.4873 25.5239Z",
    fill: "url(#paint3_linear_4805_26880)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2032 25.5239C15.1066 25.5239 15.0101 25.4984 14.9193 25.4472C14.6467 25.2911 14.5558 24.9419 14.712 24.6721L15.5325 23.2525C15.6887 22.98 16.0351 22.8863 16.3076 23.0453C16.5802 23.2014 16.671 23.5507 16.5149 23.8204L15.6943 25.24C15.5893 25.4217 15.3991 25.5239 15.2032 25.5239Z",
    fill: "url(#paint4_linear_4805_26880)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.919 25.5239C19.8225 25.5239 19.7259 25.4984 19.6351 25.4472C19.3625 25.2911 19.2717 24.9419 19.4278 24.6721L20.2483 23.2525C20.4045 22.98 20.7509 22.8863 21.0234 23.0453C21.296 23.2014 21.3869 23.5507 21.2307 23.8204L20.4102 25.24C20.3051 25.4217 20.1149 25.5239 19.919 25.5239Z",
    fill: "url(#paint5_linear_4805_26880)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4805_26880",
    x1: 8.49927,
    y1: 22.2063,
    x2: 10.4548,
    y2: 22.2063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BDF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4805_26880",
    x1: 13.074,
    y1: 22.2063,
    x2: 15.0296,
    y2: 22.2063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BDF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4805_26880",
    x1: 17.6487,
    y1: 22.2063,
    x2: 19.6043,
    y2: 22.2063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BDF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4805_26880",
    x1: 9.91919,
    y1: 24.2449,
    x2: 11.8748,
    y2: 24.2449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BDF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4805_26880",
    x1: 14.6357,
    y1: 24.2449,
    x2: 16.5912,
    y2: 24.2449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BDF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4805_26880",
    x1: 19.3519,
    y1: 24.2449,
    x2: 21.3074,
    y2: 24.2449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BDF2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowerRain);
export default __webpack_public_path__ + "static/media/shower_rain.aa000d31a92918f64b0773be037ec126.svg";
export { ForwardRef as ReactComponent };